// extracted by mini-css-extract-plugin
export default {"invoiceActionButton":"paid-invoice-status_invoiceActionButton__vwJmZ"};